const DEFAULT_BULK_ACCEPT_ERROR = 'an error';

const hasBackendErrorMessage = reason => typeof reason === 'string' && Boolean(reason.trim());

export const formatAllShipmentsFailedMessage = reason =>
  hasBackendErrorMessage(reason)
    ? reason
    : `Due to ${DEFAULT_BULK_ACCEPT_ERROR}, none of your shipments were accepted.`;

export const formatPartialShipmentsFailedMessage = (reason, failureCount, totalRequested) =>
  hasBackendErrorMessage(reason)
    ? reason
    : `Due to ${DEFAULT_BULK_ACCEPT_ERROR}, ${failureCount} of ${totalRequested} shipments were not accepted.`;

export const formatBulkAcceptGenericFailureMessage = reason =>
  hasBackendErrorMessage(reason)
    ? reason
    : `Due to ${DEFAULT_BULK_ACCEPT_ERROR}, the shipments could not be confirmed.`;
